var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('span',[_vm._v("Copyright ©2021 昆山东部软件科技有限公司 版权所有 咨询热线：0512-55136315")])])}]

export { render, staticRenderFns }